export default {
  lang_name: 'English',

  // Tabs
  tab_main: 'Main',
  tab_upgrade: 'Upgrade',
  tab_prestige: 'Prestige',
  tab_achievement: 'Achieve',
  tab_mission: 'Mission', tab_domination: 'World', tab_settings: 'Settings',

  // Conquest
  cq_title: 'World Conquest',
  cq_progress: 'Conquered',
  cq_infiltration_power: 'Infiltration Power',
  cq_active_conquest: 'Infiltrating',
  cq_infiltration_progress: 'Infiltration Progress',
  cq_time_remaining: 'Est. Time',
  cq_start_infiltration: 'Start Infiltration',
  cq_stop_infiltration: 'Stop Infiltration',
  cq_no_power_hint: 'Hire agents to generate infiltration power',
  cq_locked: 'Locked',
  cq_available: 'Available',
  cq_conquered: 'Conquered',
  cq_popup_title: 'Conquest Complete!',
  cq_popup_desc: 'has been conquered! Build facilities to grow stronger.',
  cq_back: 'Back',
  cq_invest_title: 'Invest 🛸 to Conquer',
  cq_current_ip: 'Current 🛸',
  cq_facilities: 'Facilities',
  cq_build: 'Build',
  cq_upgrade: 'Upgrade',
  cq_next_level: 'Next',
  cq_counter_intel_title: 'Counter-Intelligence Alert!',
  cq_counter_intel_text: 'Your infiltration in {country} has been detected! Progress will be reduced.',
  cq_defend_ad: 'Watch Ad to Defend',
  cq_accept_loss: 'Accept Loss',
  cq_ending_title: 'Earth Conquered!',
  cq_ending_text: 'The reptilian conspiracy is complete. All nations bow to the shadow empire.',
  cq_ending_time: 'Play Time',
  cq_ending_prestiges: 'Prestiges',
  cq_ending_total_ip: 'Total 🛸',
  cq_ending_taps: 'Total Taps',
  cq_ending_continue: 'Continue Playing',
  // Countries
  cq_egypt: 'Egypt', cq_egypt_desc: 'Ancient pyramid bases',
  cq_brazil: 'Brazil', cq_brazil_desc: 'Amazon jungle hideouts',
  cq_india: 'India', cq_india_desc: 'Naga cult infiltration',
  cq_australia: 'Australia', cq_australia_desc: 'Desert underground bunkers',
  cq_japan: 'Japan', cq_japan_desc: 'Tech theft operations',
  cq_korea: 'Korea', cq_korea_desc: 'NIS cyber defense breach',
  cq_uk: 'United Kingdom', cq_uk_desc: 'MI5/MI6 royal infiltration',
  cq_russia: 'Russia', cq_russia_desc: 'FSB Siberian operations',
  cq_china: 'China', cq_china_desc: 'World\'s strongest surveillance',
  cq_usa: 'United States', cq_usa_desc: 'CIA/NSA final boss',
  // Facilities
  fac_pyramid_vault: 'Pyramid Vault', fac_pyramid_vault_d: '🛸/s +5% per level',
  fac_nile_network: 'Nile Network', fac_nile_network_d: 'Offline +5% per level',
  fac_ancient_lab: 'Ancient Lab', fac_ancient_lab_d: 'TAP +10% per level',
  fac_amazon_hideout: 'Amazon Hideout', fac_amazon_hideout_d: 'Producer discount +2% per level',
  fac_samba_broadcast: 'Samba Broadcast', fac_samba_broadcast_d: '🛸/s +8% per level',
  fac_jungle_lab: 'Jungle Lab', fac_jungle_lab_d: 'Golden event +5% per level',
  fac_naga_temple: 'Naga Temple', fac_naga_temple_d: '💎 +5% per level',
  fac_bollywood_studio: 'Bollywood Studio', fac_bollywood_studio_d: 'Offline +8% per level',
  fac_caste_network: 'Caste Network', fac_caste_network_d: '🛸/s +12% per level',
  fac_desert_bunker: 'Desert Bunker', fac_desert_bunker_d: 'TAP +15% per level',
  fac_ayers_signal: 'Ayers Signal', fac_ayers_signal_d: 'Golden event +8% per level',
  fac_outback_base: 'Outback Base', fac_outback_base_d: '🛸/s +15% per level',
  fac_akiba_ai: 'Akihabara AI', fac_akiba_ai_d: '🛸/s +20% per level',
  fac_ninja_intel: 'Ninja Intel', fac_ninja_intel_d: 'Producer discount +3% per level',
  fac_tokyo_tower: 'Tokyo Tower', fac_tokyo_tower_d: '💎 +8% per level',
  fac_gangnam_hq: 'Gangnam HQ', fac_gangnam_hq_d: '🛸/s +25% per level',
  fac_cyber_command: 'Cyber Command', fac_cyber_command_d: 'TAP +25% per level',
  fac_kpop_brainwash: 'K-Pop Brainwash', fac_kpop_brainwash_d: '💎 +10% per level',
  fac_royal_infiltrate: 'Royal Infiltration', fac_royal_infiltrate_d: '🛸/s +30% per level',
  fac_london_tower: 'London Tower', fac_london_tower_d: 'Offline +15% per level',
  fac_mi6_double: 'MI6 Double Agent', fac_mi6_double_d: 'Golden event +12% per level',
  fac_siberia_base: 'Siberia Base', fac_siberia_base_d: '🛸/s +40% per level',
  fac_kgb_remnant: 'KGB Remnant', fac_kgb_remnant_d: 'Producer discount +5% per level',
  fac_nuke_bunker: 'Nuke Bunker', fac_nuke_bunker_d: 'TAP +40% per level',
  fac_great_wall: 'Great Firewall', fac_great_wall_d: '🛸/s +50% per level',
  fac_shenzhen_factory: 'Shenzhen Factory', fac_shenzhen_factory_d: 'Producer discount +8% per level',
  fac_panda_spy: 'Panda Spy Ring', fac_panda_spy_d: 'Golden event +20% per level',
  fac_area51: 'Area 51', fac_area51_d: '🛸/s +80% per level',
  fac_pentagon: 'Pentagon', fac_pentagon_d: 'TAP +80% per level',
  fac_wall_street: 'Wall Street', fac_wall_street_d: '💎 +25% per level',

  // HUD
  hud_cps: '/s',
  hud_boost: 'Boost',

  // Main screen
  main_tap_area: 'TAP!',
  main_combo: 'Combo',

  // Producers
  prod_informant: 'Informant',
  prod_informant_desc: 'Street-level intel gathering',
  prod_hacker: 'Hacker',
  prod_hacker_desc: 'Human network infiltration',
  prod_disguiser: 'Disguiser',
  prod_disguiser_desc: 'Human form camouflage',
  prod_mindController: 'Mind Controller',
  prod_mindController_desc: 'Human opinion manipulation',
  prod_secretLab: 'Secret Lab',
  prod_secretLab_desc: 'Reptilian tech research',
  prod_mediaCell: 'Media Cell',
  prod_mediaCell_desc: 'News & SNS takeover',
  prod_shadowGovt: 'Shadow Govt',
  prod_shadowGovt_desc: 'Politician replacement ops',
  prod_deepBase: 'Deep Base',
  prod_deepBase_desc: 'Underground mega-base',
  prod_orbitalStation: 'Orbital Station',
  prod_orbitalStation_desc: 'Satellite surveillance net',
  prod_dimensionGate: 'Dimension Gate',
  prod_dimensionGate_desc: 'Summon forces from homeworld',
  prod_planetController: 'Planet Controller',
  prod_planetController_desc: 'Direct Earth system control',
  prod_galacticBeacon: 'Galactic Beacon',
  prod_galacticBeacon_desc: 'Direct line to HQ',
  prod_locked: 'Unlock: ',
  prod_locked_prestige: 'Prestige {n}x',
  prod_locked_time: '{n}min play',

  // Milestones
  milestone_squad: 'Squad Formation',
  milestone_company: 'Company Complete',
  milestone_battalion: 'Battalion Force',
  milestone_regiment: 'Regiment Force',
  milestone_division: 'Division Force',
  milestone_corps: 'Corps Force',

  // Click upgrades
  click_basic_training: 'Basic Training',
  click_combat_training: 'Combat Training',
  click_psychic_awaken: 'Psychic Awakening',
  click_transform: 'Transform Enhance',
  click_telepathy: 'Telepathy', click_critical_eye: 'Critical Eye',
  click_dimension_sense: 'Dimension Sense', click_galaxy_field: 'Galaxy Field',
  click_lethal_strike: 'Lethal Strike', click_absolute: 'Absolute Infiltration',
  click_planet_destroyer: 'Planet Destroyer',
  click_galaxy_finger: "Galaxy Overlord's Finger",

  // Special upgrades
  special_info_network: 'Info Network',
  special_info_network_desc: 'Informant & Hacker x2',
  special_perfect_disguise: 'Perfect Disguise',
  special_perfect_disguise_desc: 'All agents x1.5',
  special_mass_brainwash: 'Mass Brainwash',
  special_mass_brainwash_desc: 'Mind Controller & Media x3',
  special_shadow_network: 'Shadow Network',
  special_shadow_network_desc: 'Offline income +25%',
  special_underground_empire: 'Underground Empire',
  special_underground_empire_desc: 'All agents x2',
  special_orbital_surveillance: 'Orbital Surveillance',
  special_orbital_surveillance_desc: 'Golden events +50% freq',
  special_dimension_supply: 'Dimension Supply Line',
  special_dimension_supply_desc: 'Tap income x5',
  special_galactic_alliance: 'Galactic Alliance',
  special_galactic_alliance_desc: '🛸 per second x10',
  special_combo_master: 'Combo Master',
  special_combo_master_desc: 'Combo cap x3',
  special_time_warp: 'Time Warp',
  special_time_warp_desc: 'Offline cap 12h',
  special_agent_synergy: 'Agent Synergy',
  special_agent_synergy_desc: '🛸 per second x1.5',
  special_massive_infiltration: 'Massive Infiltration',
  special_massive_infiltration_desc: '🛸 per second x2',

  // Sub tabs
  subtab_click: 'Click',
  subtab_special: 'Special',

  // Prestige
  prestige_title: 'Organization Restructure',
  prestige_total_ip: 'Total 🛸 earned',
  prestige_gc_gain: '💎 to gain',
  prestige_gc_current: 'Current 💎',
  prestige_execute: 'Restructure',
  prestige_confirm: 'Reset all progress for {gc} Galactic Credits?',
  prestige_ad_bonus: 'Watch ad for +50% 💎',
  prestige_requirement: 'Need 10B+ 🛸 to prestige',
  prestige2_title: 'Galaxy Restructure',
  prestige2_cores_gain: '🔮 to gain',
  prestige2_cores_current: 'Current 🔮',
  prestige2_execute: 'Galaxy Restructure',
  prestige2_requirement: 'Need 15+ prestiges & 100+ total 💎',
  prestige2_confirm: 'Deep reset everything for {cores} Galaxy Cores?',

  // Prestige upgrades
  pup_galaxy_mult: 'Galaxy Multiplier',
  pup_galaxy_mult_desc: 'CPS x1.5 per level (stacks multiplicatively)',
  pup_infil_accel: 'Infiltration Accel',
  pup_infil_accel_desc: 'Start with 100M 🛸 per level after prestige',
  pup_tap_enhance: 'Tap Enhance',
  pup_tap_enhance_desc: 'Tap income x2 per level (stacks multiplicatively)',
  pup_offline_expand: 'Offline Expand',
  pup_offline_expand_desc: 'Offline reward cap +1h/Lv (base 8h)',
  pup_offline_eff: 'Offline Efficiency',
  pup_offline_eff_desc: 'Offline income rate +10%p/Lv (base 50%)',
  pup_agent_discount: 'Agent Discount',
  pup_agent_discount_desc: 'Agent hire cost -10% per level (max -50%)',
  pup_auto_click: 'Auto Click',
  pup_auto_click_desc: 'Auto-tap 3 times/sec per level (max 15/sec)',
  pup_golden_luck: 'Golden Luck',
  pup_golden_luck_desc: 'Golden event reward +20%/Lv (max +200%)',
  pup_combo_keep: 'Combo Keep',
  pup_combo_keep_desc: 'Combo timer +0.5s/Lv (base 2s)',
  pup_quick_start: 'Quick Start',
  pup_quick_start_desc: 'Auto-grant 1 of each first 5 agents after prestige',

  // Prestige 2 upgrades
  p2up_galaxy_speed: 'Galaxy Speed',
  p2up_galaxy_speed_desc: '💎 gain x2 per level on prestige (stacks multiplicatively)',
  p2up_auto_prestige: 'Auto Prestige',
  p2up_auto_prestige_desc: 'Auto-prestige when reaching 10B 🛸',
  p2up_permanent: 'Permanent Agents',
  p2up_permanent_desc: 'Keep first 3 agent types after prestige',
  p2up_dimension_accel: 'Dimension Accel',
  p2up_dimension_accel_desc: 'CPS x5 per level (stacks, permanent)',
  p2up_galaxy_memory: 'Galaxy Memory',
  p2up_galaxy_memory_desc: 'Keep 3 active boosts through prestige',
  p2up_spacetime: 'Spacetime Warp',
  p2up_spacetime_desc: 'Offline income rate set to 100% (permanent)',
  p2up_automate: 'Galaxy Automate',
  p2up_automate_desc: 'Auto-hire agents (permanent)',

  // Ranks
  rank_e: 'Intern',
  rank_d: 'Junior Agent',
  rank_c: 'Agent',
  rank_b: 'Senior Agent',
  rank_a: 'Executive',
  rank_s: 'Director',
  rank_ss: 'Supreme Cmdr',
  rank_sss: 'Galactic Overlord',

  // Achievements
  ach_title: 'Achievements',
  ach_filter_all: 'All',
  ach_filter_tap: 'Tap',
  ach_filter_resource: 'Resource',
  ach_filter_producer: 'Producer',
  ach_filter_prestige: 'Prestige',
  ach_filter_time: 'Time',
  ach_filter_special: 'Special',
  ach_filter_ad: 'Docs',
  ach_filter_combo: 'Combo',

  ach_t01: 'First Step', ach_t01_reward: '+1 Tap Power',
  ach_t02: 'Finger Warmup', ach_t02_reward: '+5% Tap Power',
  ach_t03: 'Steady Agent', ach_t03_reward: '+10% Tap Power',
  ach_t04: 'Touch Master', ach_t04_reward: '+15% Tap Power',
  ach_t05: 'Reptilian Grit', ach_t05_reward: '+20% Tap Power',
  ach_t06: 'Galaxy Fingers', ach_t06_reward: '+25% Tap Power',
  ach_t07: 'Combo Apprentice', ach_t07_reward: '+0.5s Combo',
  ach_t08: 'Combo Master', ach_t08_reward: '+0.5 Combo Cap',

  ach_r01: 'Small Intel', ach_r01_reward: '+5% 🛸/s',
  ach_r02: 'Intel Collector', ach_r02_reward: '+5% 🛸/s',
  ach_r03: 'Classified Vault', ach_r03_reward: '+5% 🛸/s',
  ach_r04: 'Million Infiltrate', ach_r04_reward: '+10% 🛸/s',
  ach_r05: 'Billion Agent', ach_r05_reward: '+10% 🛸/s',
  ach_r06: 'Trillion Ops', ach_r06_reward: '+15% 🛸/s',
  ach_r07: 'Quadrillion Empire', ach_r07_reward: '+15% 🛸/s',
  ach_r08: 'Galaxy Ocean', ach_r08_reward: '+20% 🛸/s',
  ach_r09: 'Cosmic Universe', ach_r09_reward: '+20% 🛸/s',
  ach_r10: 'Infinite Infiltrate', ach_r10_reward: '+30% 🛸/s',

  ach_g01: 'First Recruit', ach_g01_reward: 'Informant x1.5',
  ach_g02: 'Intel Network', ach_g02_reward: 'Informant x2',
  ach_g03: 'Hacking Begins', ach_g03_reward: 'Hacker x2',
  ach_g04: 'Cyber Legion', ach_g04_reward: 'Hacker x3',
  ach_g05: 'Master of Disguise', ach_g05_reward: 'Disguiser x2',
  ach_g06: 'Brainwash Net', ach_g06_reward: 'Mind Controller x2',
  ach_g07: 'Mad Science', ach_g07_reward: 'Secret Lab x2',
  ach_g08: 'Media Control', ach_g08_reward: 'Media Cell x2',
  ach_g09: 'Shadow Cabinet', ach_g09_reward: 'Shadow Govt x2',
  ach_g10: 'Underground Empire', ach_g10_reward: 'Deep Base x2',
  ach_g11: 'Orbital Dominance', ach_g11_reward: 'Orbital Station x2',
  ach_g12: 'Master of Galaxy', ach_g12_reward: 'Total 🛸/s x2',

  ach_p01: 'First Restructure', ach_p01_reward: '+5 💎 Bonus',
  ach_p02: 'Taste of Cycle', ach_p02_reward: '+10% 💎',
  ach_p03: 'Veteran Agent', ach_p03_reward: '+10% 💎',
  ach_p04: 'Prestige Addict', ach_p04_reward: '+15% 💎',
  ach_p05: 'Infinite Loop', ach_p05_reward: '+20% 💎',
  ach_p06: 'Galaxy Memory', ach_p06_reward: '+25% 💎',
  ach_p07: 'Galaxy Restructure', ach_p07_reward: '+3 🔮 Bonus',
  ach_p08: 'Dimension Lord', ach_p08_reward: '+20% 🔮',

  ach_h01: 'New Recruit', ach_h01_reward: 'Welcome Bonus 100 🛸',
  ach_h02: '1 Hour Shift', ach_h02_reward: '+5% 🛸/s',
  ach_h03: 'Half Day', ach_h03_reward: '+10% 🛸/s',
  ach_h04: '24h Stakeout', ach_h04_reward: 'Offline +2h',
  ach_h05: '3 Day Mission', ach_h05_reward: '🛸/s x1.5',
  ach_h06: 'Week Infiltration', ach_h06_reward: '🛸/s x2',

  ach_s01: 'Suspicious Human', ach_s01_reward: '1 Doc',
  ach_s02: 'Clean Start', ach_s02_reward: 'Title: Reckless Agent',
  ach_s03: 'All In', ach_s03_reward: '+10% 🛸/s',
  ach_s04: 'Speed Run', ach_s04_reward: '+10 💎 Bonus',
  ach_s05: 'Golden Hunter', ach_s05_reward: 'Event freq -20%',
  ach_s06: 'Night Agent', ach_s06_reward: 'Night 🛸/s x1.5',
  ach_s07: 'F2P Warrior', ach_s07_reward: 'Ad reward +30%',
  ach_s08: 'Collector', ach_s08_reward: '🛸/s x3',

  ach_a01: 'Ad Beginner', ach_a01_reward: '1 Doc',
  ach_a02: 'Ad Enthusiast', ach_a02_reward: '2 Docs',
  ach_a03: 'Ad Master', ach_a03_reward: 'Ad reward +30%',
  ach_a04: 'Doc Collector', ach_a04_reward: 'Doc effect +20%',
  ach_a05: 'Doc Expert', ach_a05_reward: 'Doc effect +50%',

  ach_c01: 'Combo Start', ach_c01_reward: '+0.3s Combo',
  ach_c02: 'Riding Rhythm', ach_c02_reward: '+0.1 Combo mult',
  ach_c03: 'Golden Beginner', ach_c03_reward: 'Event reward +10%',
  ach_c04: 'Golden Collector', ach_c04_reward: 'Event freq -10%',
  ach_c05: 'Daily Maniac', ach_c05_reward: 'Mission reward +50%',

  // Golden events
  golden_intel_leak: 'Intel Leak!',
  golden_agent_frenzy: 'Agent Frenzy!',
  golden_money_launder: 'Money Laundering!',
  golden_facility_boost: 'Facility Overdrive!',
  golden_supply_drop: 'Galaxy Supply Drop!',
  golden_touch: 'TAP!',
  golden_ad_double: 'Watch ad for 2x',

  // Offline
  offline_title: 'Absence Report',
  offline_elapsed: 'Time elapsed',
  offline_earned: '🛸 earned',
  offline_cap: 'Max {h}h applied',
  offline_claim: 'Claim',
  offline_double: 'Watch ad for 2x ({amount})',
  offline_hours: '{h}h {m}m',

  // Settings
  settings_title: 'Settings',
  settings_bgm: 'BGM',
  settings_sfx: 'SFX',
  settings_lang: 'Language',
  settings_reset: 'Reset Game',
  settings_reset_confirm: 'Delete ALL progress and start over?',
  settings_stats: 'Statistics',
  settings_total_ip: 'Total 🛸 Earned',
  settings_total_taps: 'Total Taps',
  settings_total_prestiges: 'Total Prestiges',
  settings_play_time: 'Total Play Time',
  settings_docs_shop: 'Classified Docs Shop',

  // Doc shop
  doc_shop_title: 'Classified Docs Shop',
  doc_ip_boost: 'Auto Income Boost', doc_ip_boost_desc: '2x 🛸/s production for 30 seconds',
  doc_mega_tap: 'Power Tap Training', doc_mega_tap_desc: '3x tap income for 30 seconds',
  doc_auto_click: 'Auto-Infiltrator', doc_auto_click_desc: 'Auto-tap 10 times/sec for 30 seconds',
  doc_instant_golden: 'Emergency Golden Call', doc_instant_golden_desc: 'Trigger golden event instantly',
  doc_timeskip: 'Time Accelerator', doc_timeskip_desc: 'Instantly earn 2 hours of 🛸 income',
  doc_prestige_boost: 'Galaxy Amplifier', doc_prestige_boost_desc: '2x 💎 gain on next prestige',
  doc_prestige_boost_active: '💎 x2 pending for next prestige', doc_prestige_boost_active_badge: '✅ Active',

  // Ad rewards
  ad_offline_double: 'Double offline reward',
  ad_cps_boost: '/sec income x10 Boost (15s)',
  ad_prestige_bonus: 'Prestige +50% 💎',
  ad_timeskip: 'Time Skip (2h)',
  ad_free_docs: 'Free Classified Docs',
  ad_golden_double: 'Double golden reward',
  ad_start_boost: 'Start Boost Pack',
  ad_watching: 'Loading ad...',
  ad_cooldown: 'Available in {t}',
  settings_sfx_test: 'Test SFX',
  settings_sound_reset: 'Reset',
  settings_sound_reset_done: 'Sound reset to default',

  // Numbers
  num_k: 'K',
  num_m: 'M',
  num_b: 'B',
  num_t: 'T',
  num_qa: 'Qa',
  num_qi: 'Qi',
  num_sx: 'Sx',
  num_sp: 'Sp',
  num_oc: 'Oc',
  num_no: 'No',
  num_dc: 'Dc',

  // Daily Missions
  mission_title: 'Daily Missions',
  mission_claim: 'Claim',
  mission_all_complete: 'All Complete Bonus!',
  mission_clear_label: 'MISSION',
  mission_all_clear_label: 'ALL CLEAR',
  ach_unlock_label: 'ACHIEVEMENT',
  mission_diff_easy: 'Easy',
  mission_diff_normal: 'Med',
  mission_diff_hard: 'Hard',
  mission_tap_100: 'Light Touch',
  mission_tap_100_desc: 'Tap 100 times',
  mission_tap_300: 'Warm Hands',
  mission_tap_300_desc: 'Tap 300 times',
  mission_buy_5: 'Small Recruit',
  mission_buy_5_desc: 'Buy 5 producers',
  mission_combo_10: 'Combo Starter',
  mission_combo_10_desc: 'Reach 10 combo',
  mission_golden_1: 'Lucky Catch',
  mission_golden_1_desc: 'Catch 1 golden event',
  mission_tap_1000: 'Heavy Hitter',
  mission_tap_1000_desc: 'Tap 1,000 times',
  mission_buy_20: 'Squad Builder',
  mission_buy_20_desc: 'Buy 20 producers',
  mission_combo_50: 'Combo Pro',
  mission_combo_50_desc: 'Reach 50 combo',
  mission_golden_3: 'Gold Rush',
  mission_golden_3_desc: 'Catch 3 golden events',
  mission_earn_1m: 'Million Ops',
  mission_earn_1m_desc: 'Earn 1M 🛸',
  mission_tap_5000: 'Tap Machine',
  mission_tap_5000_desc: 'Tap 5,000 times',
  mission_buy_50: 'Army Builder',
  mission_buy_50_desc: 'Buy 50 producers',
  mission_combo_100: 'Combo God',
  mission_combo_100_desc: 'Reach 100 combo',
  mission_golden_5: 'Golden Master',
  mission_golden_5_desc: 'Catch 5 golden events',
  mission_earn_1b: 'Billion Agent',
  mission_earn_1b_desc: 'Earn 1B 🛸',
  // New missions
  mission_tap_200: 'Quick Fingers',
  mission_tap_200_desc: 'Tap 200 times',
  mission_buy_3: 'First Recruits',
  mission_buy_3_desc: 'Buy 3 producers',
  mission_combo_15: 'Combo Beginner',
  mission_combo_15_desc: 'Reach 15 combo',
  mission_earn_10k: 'Pocket Money',
  mission_earn_10k_desc: 'Earn 10K 🛸',
  mission_earn_100k: 'Fund Raiser',
  mission_earn_100k_desc: 'Earn 100K 🛸',
  mission_tap_500: 'Steady Tapper',
  mission_tap_500_desc: 'Tap 500 times',
  mission_tap_700: 'Relentless',
  mission_tap_700_desc: 'Tap 700 times',
  mission_buy_10: 'Team Leader',
  mission_buy_10_desc: 'Buy 10 producers',
  mission_combo_30: 'Combo Chain',
  mission_combo_30_desc: 'Reach 30 combo',
  mission_golden_2: 'Double Gold',
  mission_golden_2_desc: 'Catch 2 golden events',
  mission_tap_3000: 'Tap Warrior',
  mission_tap_3000_desc: 'Tap 3,000 times',
  mission_buy_30: 'Battalion',
  mission_buy_30_desc: 'Buy 30 producers',
  mission_combo_75: 'Combo Elite',
  mission_combo_75_desc: 'Reach 75 combo',
  mission_golden_4: 'Gold Hunter',
  mission_golden_4_desc: 'Catch 4 golden events',
  mission_earn_10m: 'Tycoon',
  mission_earn_10m_desc: 'Earn 10M 🛸',

  // Misc
  buy: 'Buy',
  max: 'MAX',
  level: 'Lv.',
  locked: 'Locked',
  upgrade_locked_prev: 'Learn the previous upgrade first',
  unlocked: 'Unlocked',
  condition: 'Condition',
  cost: 'Cost',
  owned: 'Owned',
  effect: 'Effect',
  reward: 'Reward',
  close: 'Close',
  confirm: 'Confirm',
  cancel: 'Cancel',

  // Conquest achievements
  ach_filter_conquest: 'Conquest',
  ach_q01: 'First Conquest', ach_q01_reward: '+10% 🛸/s',
  ach_q02: 'Triple Threat', ach_q02_reward: '+10% TAP',
  ach_q03: 'Half the World', ach_q03_reward: '+15% 💎',
  ach_q04: 'Seven Flags', ach_q04_reward: '+20% Offline',
  ach_q05: 'World Dominator', ach_q05_reward: '🛸/s x3',
  ach_q06: 'Facility Master', ach_q06_reward: '🛸/s x2',
  milestone_next: 'Next',
  settings_conquest: 'Conquest',

  // Currency info
  currency_ip_name: 'Infiltration Points (IP)',
  currency_ip_earn: 'Earn by tapping, agent auto-production, offline income, and ad rewards',
  currency_ip_use: 'Hire agents, buy upgrades, invest in country conquest',
  currency_gc_name: 'Galactic Credits (GC)',
  currency_gc_earn: 'Earned by prestiging (Organization Restructure) based on total IP',
  currency_gc_use: 'Buy prestige upgrades (production multiplier, offline efficiency, etc.)',
  currency_cores_name: 'Galaxy Cores',
  currency_cores_earn: 'Earned by 2nd prestige (Galaxy Restructure) based on total GC',
  currency_cores_use: 'Buy 2nd prestige upgrades (permanent buffs, automation, etc.)',
  currency_docs_name: 'Classified Docs',
  currency_docs_earn: 'Complete daily missions, watch ads, or unlock achievements',
  currency_docs_use: 'Buy powerful boosts in the Doc Shop (Mission tab)',
  currency_how_earn: 'How to earn',
  currency_how_use: 'How to use',

  // Prestige upgrades - conquest
  pup_infiltration_mastery: 'Infiltration Mastery',
  pup_infiltration_mastery_desc: 'Total infiltration power +50%/Lv (max +500%)',
  pup_agent_network: 'Agent Network',
  pup_agent_network_desc: 'Infiltration +5% per 100 agents per level',
  pup_quick_infiltration: 'Chain Infiltration',
  pup_quick_infiltration_desc: 'Next country starts with +10% progress/Lv on conquest',
  pup_critical_chance: 'Critical Training',
  pup_critical_chance_desc: 'Tap crit chance +3%/Lv (base 10%, max 50%)',
  pup_critical_damage: 'Critical Power',
  pup_critical_damage_desc: 'Crit damage +1x/Lv (base x3)',

  // Special upgrades - conquest
  special_spy_master: 'Spy Master',
  special_spy_master_desc: 'All infiltration power x2',

  ad_income_x5: 'Get 30min Income',
  ad_income_x5_desc: 'Watch an ad to instantly earn\n{amount} 🛸 (30 minutes of income)!',
  ad_tap_x10: 'Tap x10 (10s)',
  ad_tap_x10_desc: 'Watch an ad to boost\ntap income by 10x for 10 seconds!',
  ad_free_docs_desc: 'Watch an ad to get\n1 free Classified Document 📜!',
  ad_prestige_desc: 'Watch an ad to boost\nincome by 10x for 15 seconds!',
  cq_tutorial_title: '🌍 World Conquest Guide',
  cq_tutorial_text: 'After conquering a country, you can build <b>facilities</b>!\nUpgrade them for permanent bonuses like\n<b>🛸/s, tap income, offline income</b> and more.\n\nHire agents to increase infiltration power.',
  rank_promote: 'Promote',
  rank_promoted: 'Promoted!',
} as const;
